import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import mq from '../../../styleUtility/mediaquery';

interface Props {
  className?: string;
}

const EmptyState = ({ className }: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      <Svg width="944" height="376" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <defs>
          <path id="b" d="M0 0h928v117H0z" />
          <filter x="-1.1%" y="-6%" width="102.2%" height="118.8%" filterUnits="objectBoundingBox" id="a">
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter2" />
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
              in="shadowBlurOuter2"
              result="shadowMatrixOuter2"
            />
            <feMorphology radius="1" in="SourceAlpha" result="shadowSpreadOuter3" />
            <feOffset dy="3" in="shadowSpreadOuter3" result="shadowOffsetOuter3" />
            <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter3" result="shadowBlurOuter3" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
              in="shadowBlurOuter3"
              result="shadowMatrixOuter3"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="shadowMatrixOuter2" />
              <feMergeNode in="shadowMatrixOuter3" />
            </feMerge>
          </filter>
          <path id="d" d="M0 0h928v117H0z" />
          <filter x="-1.1%" y="-6%" width="102.2%" height="118.8%" filterUnits="objectBoundingBox" id="c">
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter2" />
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
              in="shadowBlurOuter2"
              result="shadowMatrixOuter2"
            />
            <feMorphology radius="1" in="SourceAlpha" result="shadowSpreadOuter3" />
            <feOffset dy="3" in="shadowSpreadOuter3" result="shadowOffsetOuter3" />
            <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter3" result="shadowBlurOuter3" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
              in="shadowBlurOuter3"
              result="shadowMatrixOuter3"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="shadowMatrixOuter2" />
              <feMergeNode in="shadowMatrixOuter3" />
            </feMerge>
          </filter>
          <path id="f" d="M0 0h928v117H0z" />
          <filter x="-1.1%" y="-6%" width="102.2%" height="117.1%" filterUnits="objectBoundingBox" id="e">
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter2" />
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
              in="shadowBlurOuter2"
              result="shadowMatrixOuter2"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="shadowMatrixOuter2" />
            </feMerge>
          </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g opacity=".4">
            <g transform="translate(8 47)">
              <use fill="#000" filter="url(#a)" xlinkHref="#b" />
              <use fill="#FFF" xlinkHref="#b" />
            </g>
            <path
              fill="#ebedef"
              d="M29 63h172v25H29zM29 111h71v13H29zM29 130h71v13H29zM201 108h71v13h-71zM201 127h71v13h-71zM383 108h71v13h-71zM383 127h71v13h-71z"
            />
          </g>
          <g opacity=".4">
            <g transform="translate(8 184)">
              <use fill="#000" filter="url(#c)" xlinkHref="#d" />
              <use fill="#FFF" xlinkHref="#d" />
            </g>
            <path
              fill="#ebedef"
              d="M29 200h172v25H29zM29 248h71v13H29zM29 267h71v13H29zM201 245h71v13h-71zM201 264h71v13h-71zM383 245h71v13h-71zM383 264h71v13h-71z"
            />
          </g>
          <g opacity=".4">
            <g transform="translate(8 321)">
              <use fill="#000" filter="url(#e)" xlinkHref="#f" />
              <use fill="#FFF" xlinkHref="#f" />
            </g>
            <path fill="#ebedef" d="M29 337h172v25H29z" />
          </g>
          <path d="M818.008 13C784.226 43.07 745.983 59.02 705 77.578" stroke="#88E18E" strokeWidth="2" />
          <path fill="#88E18E" d="M823.903 7.415l-3.639 15.387L808.22 9.425z" />
        </g>
      </Svg>

      <Text align="right">
        <FormattedMessage id="projects_list.empty_state_message" />
      </Text>
    </Root>
  );
};

const Root = styled('div')({ position: 'relative' });

const Svg = styled('svg')({
  maxWidth: '100%',
  [mq('sp')]: {
    display: 'none',
  },
});

const Text = styled(Typography)({
  position: 'absolute',
  top: 90,
  right: 20,
  left: 20,
  fontSize: 20,
  fontWeight: 700,
  textAlign: 'center',
});

export default EmptyState;
